module.exports = __webpack_public_path__ + "static/media/laporan_pembayaran_ppdb.e8f61a9c.png";